// Outreach — bucket page that groups Inbox / Creators / Meetings as sub-tabs.
//
// Each tab renders the existing standalone page component unchanged. Tab
// state lives in the URL (?tab=...) so deep links from the old top-level
// routes (/creators, /meetings) survive via redirects.

import { useSearchParams } from 'react-router-dom';
import { Inbox } from './Inbox';
import { Creators } from './Creators';
import { Meetings } from './Meetings';

type TabId = 'inbox' | 'creators' | 'meetings';
const VALID: TabId[] = ['inbox', 'creators', 'meetings'];
const TABS: Array<{ id: TabId; label: string }> = [
  { id: 'inbox', label: 'Inbox' },
  { id: 'creators', label: 'Creators' },
  { id: 'meetings', label: 'Meetings' },
];

export function Outreach() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab') as TabId | null;
  const tab: TabId = raw && VALID.includes(raw) ? raw : 'inbox';

  const setTab = (id: TabId) => {
    params.set('tab', id);
    setParams(params, { replace: true });
  };

  return (
    <div className="bucket">
      <nav className="bucket__tabs" aria-label="Outreach views">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`bucket__tab ${tab === t.id ? 'bucket__tab--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <div className="bucket__body">
        {tab === 'inbox' && <Inbox />}
        {tab === 'creators' && <Creators />}
        {tab === 'meetings' && <Meetings />}
      </div>
    </div>
  );
}
